import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearPartsActions, clearSelectedPartAction, getPartsActions } from '../../redux/actions/partsActions';

const useFetchParts = ({ unpaged = false }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.parts?.search);
  const parts = useSelector((state) => state.parts?.parts);
  const loading = useSelector((state) => state.parts?.loading);

  const fetchParts = useCallback(async () => {
    await dispatch(getPartsActions(search, unpaged));
  }, [search, unpaged, dispatch]);

  useEffect(() => {
    fetchParts();
  }, [fetchParts]);

  useEffect(() => {
    return () => {
      dispatch(clearPartsActions());
      dispatch(clearSelectedPartAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchParts();
  };

  return { loading, parts, refresh };
};

export default useFetchParts;
